import ZSteps from './steps.vue';
import ZStepsMany from './steps-many.vue'

ZSteps.many = ZStepsMany;
export default ZSteps